module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-16x9-607f969b5881907de11f4e2f222fd512.jpg";